<template>
  <V2Category
    v-if="items.length > 0"
    :category="synthesizedCategory"
    :local-cart-items="synthesizedLocalCartItems"
    :server-cart-items="[]"
    :offer-collapse-functionality="false"
    :unavailable="true"
  />
</template>

<script>
import { inject, provide, ref } from 'vue'
import V2Category from '@/components/v2/V2Category'

export default {
  name: 'V2NoLongerAvailableCategory',
  components: { V2Category },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const updateUnavailable = inject('v2UpdateUnavailableCartItem', null)

    function handleUpdate(submittableCartItem) {
      if (!updateUnavailable) return
      updateUnavailable({
        category_product_store_pair_id: submittableCartItem.category_product_store_pair_id,
        quantity: submittableCartItem.quantity,
        cart_item_variant_options_attributes: submittableCartItem.cart_item_variant_options_attributes || []
      })
    }

    // The Remove control on each unavailable card comes back through here, so a removal reaches
    // updateUnavailableCartItem rather than the shared updateCartItem, which cannot match a line
    // the snapshot filtered out.
    provide('v2UpdateCartItem', handleUpdate)
    provide('v2AddCustomization', () => {})
    provide('v2HideCustomizeAnother', ref(true))
    // These products are synthesized from unavailable cart lines, so they are absent from the
    // store snapshot the modal host reads - a modal opened on one could only render empty. The
    // cards here are non-interactive, so this is a backstop rather than the mechanism.
    provide('v2OpenProductModal', () => {})
  },
  computed: {
    synthesizedCategory() {
      return {
        id: 'unavailable',
        type: 'Category',
        name: 'Unavailable items',
        description: "These items are no longer available for the fulfillment option you've selected.",
        limits: { min_items: 0, or_allow_no_items: true },
        products: this.items.map((item) => this.synthesizeProduct(item))
      }
    },
    synthesizedLocalCartItems() {
      return this.items.map((item) => ({
        frontend_key: `unavailable-${item.category_product_store_pair_id}`,
        category_product_store_pair_id: item.category_product_store_pair_id,
        quantity: item.quantity,
        cart_item_variant_options_attributes: (item.variants || []).flatMap((v) =>
          (v.variant_options || []).map((vo) => ({
            variant_option_id: vo.id,
            variant_id: v.id,
            quantity: vo.quantity || 1
          }))
        )
      }))
    }
  },
  methods: {
    synthesizeProduct(item) {
      if (item.product) return item.product
      const cents = item.product_price_formatted?.cents ?? 0
      return {
        id: item.product_id,
        cpsp_id: item.category_product_store_pair_id,
        cpsp_order: 0,
        name: item.product_name,
        description: item.product_description || '',
        price_cents: cents,
        price_formatted: item.product_price_formatted,
        quantity_step: 1,
        quantity_name: null,
        max_per_order: 0,
        product_inventory_remaining: 999999,
        store_inventory_remaining: 999999,
        labels: [],
        nutritional_information: null,
        variants: [],
        attachments: item.product_image_url ? [{ url: item.product_image_url }] : [],
        membership_prices: [],
        show_prices: true,
        allows_autofill: false,
        type: 'Product'
      }
    }
  }
}
</script>
